import {Routes} from "@angular/router";

export const EventRoutes: Routes = [
    {
        path: "",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-main/event-main.page").then(
                (m) => m.EventMainPage
            ),
    },
    {
        path: "event-edit/:eventUid",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-edit/event-edit.page").then(
                (m) => m.EventEditPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-session-main",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-session-main/event-session-main.page").then(
                (m) => m.EventSessionMainPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-category-main",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-category-main/event-category-main.page").then(
                (m) => m.EventCategoryMainPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-ticket-main",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-ticket-main/event-ticket-main.page").then(
                (m) => m.EventTicketMainPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-zone-access",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-zone-access/event-zone-access.page").then(
                (m) => m.EventZoneAccessPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-scan",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-scan/event-scan.page").then(
                (m) => m.EventScanPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-offline-sales",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-offline-sales/event-offline-sales.page").then(
                (m) => m.EventOfflineSalesPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-zone-main",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-zone-main/event-zone-main.page").then(
                (m) => m.EventZoneMainPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-zone-main/:eventZoneUid/event-program-main",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-program-main/event-program-main.page").then(
                (m) => m.EventProgramMainPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-zone-main/:eventZoneUid/event-program-main/:eventProgramUid/event-program-edit",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/event-program-edit/event-program-edit.page").then(
                (m) => m.EventProgramEditPage
            ),
    },
    {
        path: "event-edit/:eventUid/event-zone-main/:eventZoneUid/edit-event-zone",
        loadComponent: () =>
            import("@/app/domains/marketplace/events/pages/edit-event-zone/edit-event-zone.page").then(
                (m) => m.EditEventZonePage
            ),
    },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full",
    },
];
